module.exports = __webpack_public_path__ + "static/media/YB5F08_0.ff05be0a.jpg";